import clsx from 'clsx'
import PropTypes from 'prop-types'

const LinesEllipsis = (props) => {
  const {
    component: Component = 'div',
    text,
    lineHeight,
    maxLine = 1,
    style = {},
    overflowFallback = true,
    ...rest
  } = props
  const maxLineNumber = +maxLine || 1
  let usedStyle = {
    ...style,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: maxLineNumber,
  }
  if (overflowFallback && lineHeight) {
    const lineHeightNumber = parseFloat(lineHeight)
    const unit =
      typeof lineHeight === 'string' && lineHeight.trim().endsWith('em')
        ? 'em'
        : 'px'
    usedStyle = {
      ...usedStyle,
      lineHeight: `${lineHeightNumber}${unit}`,
      maxHeight: `${maxLineNumber * lineHeightNumber}${unit}`,
      overflow: 'hidden',
    }
  }
  return (
    <Component {...rest} style={usedStyle}>
      {text}
    </Component>
  )
}

LinesEllipsis.propTypes = {
  component: PropTypes.elementType,
  lineHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxLine: PropTypes.number,
  overflowFallback: PropTypes.bool,
  style: PropTypes.object,
  text: PropTypes.string,
}

const MultilineEllipsis = (props) => {
  const { className, maxLine = 1, text, ...rest } = props
  return (
    <LinesEllipsis
      className={clsx(className, 'overflow-hidden whitespace-pre-wrap')}
      dangerouslySetInnerHTML={{ __html: text }}
      maxLine={maxLine}
      {...rest}
    />
  )
}

MultilineEllipsis.propTypes = {
  className: PropTypes.string,
  maxLine: PropTypes.number,
  text: PropTypes.string,
}

export default MultilineEllipsis
